import React, { ReactElement } from "react";
import { DefaultLogoProps, ILogoProps } from "./Logo.types";

const renderLogo = (props: ILogoProps): ReactElement<React.FC> => {
  const { color, width } = props;

  return (
    <div style={{ width: `${width}px` }}>
      <a href="https://www.consumersenergy.com/">
        <svg viewBox="0 0 1028.43994140625 247.50999450683594" version="1.1">
          <path
            fill={color}
            transform="translate(-20.2 -35.23)"
            d="M892.18,72.63C787.32,48.51,640.44,35.23,478.6,35.23c-222.15,0-354.42,8.26-456.54,28.5a2.31,2.31,0,0,0,.86,4.53c83.64-15.05,229.36-23.69,399.81-23.69q14.17,0,28.26.08c161.56.92,298.42,14.21,395.77,38.44,84.83,21.11,133.49,49.57,133.49,78.08,0,21.59-11.44,44.33-94.46,64.32-88.36,21.28-245.55,37.37-494.69,50.64a2.31,2.31,0,0,0,.12,4.61h0l125.23-.2c189.86-8.39,323.92-22.47,409.82-43,81-19.38,120.38-45.14,120.38-78.73C1046.65,126.14,991.79,95.55,892.18,72.63Z"
          />
          <path
            fill={color}
            transform="translate(-20.2 -35.23)"
            d="M87.42,134.8c.71-3,2-8.64-2.41-8.64-5.62,0-6.66,3.53-11.32,23.47-4.81,20.53-5,23.48.34,23.48,3.45,0,5.6-3.14,7.64-11.88l1.27-5.41h21l-1,4.42C99,176.65,89.58,186.08,70.67,186.08c-27.77,0-24.48-14.05-19.24-36.45,5.08-21.7,8.52-36.44,36.29-36.44,23,0,23.07,11.3,20.52,22.2l-1.19,5.11h-21Z"
          />
          <path
            fill={color}
            transform="translate(-20.2 -35.23)"
            d="M161.43,158.08c-3.51,15-9,28-32.15,28s-22.57-13-19.06-28,9-27.89,32.13-27.89,22.58,13,19.08,27.89M132.18,173.7c3.78,0,5.4-3.24,8.29-15.62s2.79-15.61-1-15.61-5.4,3.24-8.3,15.61-2.79,15.62,1,15.62"
          />
          <path
            fill={color}
            transform="translate(-20.2 -35.23)"
            d="M199.7,149.54c.93-4-.19-5.21-2.89-5.21s-4.72,2.16-5.43,5.21l-8.23,35.16h-21l12.43-53.14h20.31l-1.42,6.09h.22c4.35-5.2,10.17-7.46,17.19-7.46,7.46,0,13.39,3.73,11.12,13.45l-9.61,41.06h-21Z"
          />
          <path
            fill={color}
            transform="translate(-20.2 -35.23)"
            d="M241.65,167.61c-.32,2.26-.6,3.93-.14,5.21s1.57,2.06,4,2.06a5.49,5.49,0,0,0,5.28-4.12c.6-2.56.14-3.35-6.85-5.8-12.5-4.32-17.88-7.17-15.6-16.9,2.5-10.7,10.88-17.87,27.08-17.87,23.34,0,20.63,11.59,19.48,16.5H257.13a6.55,6.55,0,0,0,0-3.83c-.52-1-1.6-1.48-3.87-1.48s-4.59.69-5.28,3.64c-.59,2.55,2,3.53,13.68,7.56,5.4,1.87,11.93,4.42,9.29,15.72-3.08,13.16-15.18,17.78-28.14,17.78-15.23,0-22.71-3.64-19.56-18.47Z"
          />
          <path
            fill={color}
            transform="translate(-20.2 -35.23)"
            d="M305.58,178.61h-.22c-4.35,5.21-10.17,7.47-17.2,7.47-7.45,0-13.39-3.73-11.11-13.46l9.61-41.06h21l-8.23,35.17c-.94,4,.18,5.2,2.88,5.2s4.72-2.16,5.44-5.2l8.23-35.17h20.95L324.46,184.7H304.15Z"
          />
          <path
            fill={color}
            transform="translate(-20.2 -35.23)"
            d="M400,149.54c.94-4-.19-5.21-2.89-5.21s-4.72,2.16-5.43,5.21l-8.22,35.16h-21l8.22-35.16c.94-4-.19-5.21-2.89-5.21s-4.72,2.16-5.43,5.21l-8.22,35.16h-21l12.43-53.14h20.31l-1.43,6.09h.22c4.35-5.2,10.17-7.46,17.2-7.46,5.62,0,10.4,2.16,12.19,7.46,4.24-5.2,10.06-7.46,17.09-7.46,7.45,0,13.39,3.73,11.11,13.45l-9.6,41.06h-21Z"
          />
          <path
            fill={color}
            transform="translate(-20.2 -35.23)"
            d="M444.61,168.2c-.67,2.85-1.35,6.68,3,6.68,4.1,0,5.34-3.44,6.6-8.84h19c-1.7,7.27-5,12.28-9.88,15.42s-11.12,4.62-18.25,4.62c-23.13,0-22.58-13-19.07-28s9-27.89,32.14-27.89c23.88,0,20.92,13.55,17,30.15l-.21.89H446.24Zm13.79-20.14c1.21-5.2.26-6.67-3.09-6.67-3,0-4.77,1.47-6,6.67l-.73,3.15h9.07Z"
          />
          <path
            fill={color}
            transform="translate(-20.2 -35.23)"
            d="M488.73,131.56H509l-1.84,7.86h.21c3.25-5.11,8.86-9.23,14.59-9.23a15.44,15.44,0,0,1,3.5.29l-4.07,17.39c-.73-.1-1.58-.2-2.52-.3s-1.82-.09-4-.09c-7.24,0-9.77,3.43-11.24,9.72l-6.43,27.5h-21Z"
          />
          <path
            fill={color}
            transform="translate(-20.2 -35.23)"
            d="M540.74,167.61c-.31,2.26-.59,3.93-.14,5.21s1.58,2.06,3.95,2.06a5.49,5.49,0,0,0,5.29-4.12c.6-2.56.13-3.35-6.86-5.8-12.49-4.32-17.87-7.17-15.6-16.9,2.51-10.7,10.88-17.87,27.09-17.87,23.34,0,20.62,11.59,19.48,16.5H556.22a6.48,6.48,0,0,0,0-3.83c-.53-1-1.6-1.48-3.87-1.48s-4.59.69-5.28,3.64c-.6,2.55,2,3.53,13.68,7.56,5.4,1.87,11.93,4.42,9.29,15.72-3.08,13.16-15.18,17.78-28.15,17.78-15.23,0-22.7-3.64-19.55-18.47Z"
          />
          <polygon
            fill={color}
            points="588.51 79.34 634.97 79.34 631.24 95.25 606.39 95.25 603.87 106.06 627.1 106.06 623.51 121.38 600.28 121.38 597.44 133.56 623.26 133.56 619.53 149.47 572.1 149.47 588.51 79.34"
          />
          <path
            fill={color}
            transform="translate(-20.2 -35.23)"
            d="M685.41,149.54c1-4-.18-5.21-2.88-5.21s-4.72,2.16-5.44,5.21l-8.22,35.16h-21l12.43-53.14h20.31l-1.42,6.09h.21c4.35-5.2,10.18-7.46,17.2-7.46,7.46,0,13.39,3.73,11.11,13.45l-9.6,41.06h-21Z"
          />
          <path
            fill={color}
            transform="translate(-20.2 -35.23)"
            d="M729.93,168.2c-.67,2.85-1.35,6.68,3,6.68,4.11,0,5.35-3.44,6.61-8.84h19c-1.7,7.27-5,12.28-9.88,15.42s-11.12,4.62-18.26,4.62c-23.12,0-22.57-13-19-28s9-27.89,32.13-27.89c23.87,0,20.92,13.55,17,30.15l-.21.89H731.56Zm13.79-20.14c1.21-5.2.26-6.67-3.09-6.67-3,0-4.78,1.47-6,6.67l-.74,3.15H743Z"
          />
          <path
            fill={color}
            transform="translate(-20.2 -35.23)"
            d="M774,131.56h20.31l-1.84,7.86h.22c3.25-5.11,8.86-9.23,14.58-9.23a15.28,15.28,0,0,1,3.5.29l-4.07,17.39q-1.09-.15-2.52-.3c-.95-.09-1.81-.09-4-.09-7.24,0-9.78,3.43-11.25,9.72l-6.43,27.5h-21Z"
          />
          <path
            fill={color}
            transform="translate(-20.2 -35.23)"
            d="M845.2,131.56h20l-11.92,51c-3.61,15.43-15.11,20.23-30.45,20.23-21.94,0-21.12-9-20.19-15.31h19a3.67,3.67,0,0,0,.28,2.94c.65.88,1.67,1.18,3.18,1.18,3.57,0,5.37-1.28,6.23-4.91l2.46-10.51h-.22c-3.81,5.2-9.15,6.77-14.87,6.77-13.84,0-13.49-13.45-10.6-25.83,2.8-12,7.48-26.91,24.44-26.91,6.6,0,9.87,2.65,10.89,7.95h.22Zm-8.39,12.77c-4.11,0-5.65,3.83-8,13.76-1.72,7.36-2,11.29,2,11.29,4.22,0,5.79-3.93,7.51-11.29,2.32-9.93,2.57-13.76-1.54-13.76"
          />
          <path
            fill={color}
            transform="translate(-20.2 -35.23)"
            d="M871.17,131.56h21.62l-2.25,32.22h.22l12.29-32.22h21l-27.34,52.65C890,196.88,886.25,202,870.48,202a46.35,46.35,0,0,1-9.74-.88l2.89-12.38a49.23,49.23,0,0,0,5.45.29,5.63,5.63,0,0,0,4.13-1.47A5.57,5.57,0,0,0,875,184.7Z"
          />
        </svg>
      </a>
    </div>
  );
};

const DESKTOP_LOGO: React.FC<ILogoProps> = (props: ILogoProps) => {
  return renderLogo(props);
};

DESKTOP_LOGO.defaultProps = DefaultLogoProps;
export default DESKTOP_LOGO;
